import { ActionIcon, Flex, Group, Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Enlistment } from 'models/user';
import { BsEye } from 'react-icons/bs';
import { useDrawerContext } from 'context/hooks';
import { PatientPrescriptionsDrawer } from 'pages/Main/Patients/Details/PatientInfo/PatientPrescriptionsDrawer';
import { GroupProgressBarItem } from './GroupProgressBarItem';

interface GroupProgressBarProps {
  groupList?: Enlistment[];
}

export const GroupProgressBar = ({ groupList }: GroupProgressBarProps) => {
  const { t } = useTranslation();
  const { openDrawer } = useDrawerContext();

  return (
    <>
      {groupList &&
        groupList.map((group, index) => (
          <Flex key={`${group}-${index}`} align={'center'}>
            {index === 0 && (
              <Group gap={'xs'}>
                <GroupProgressBarItem group={group} w={150} />
                {groupList.length > 1 && (
                  <Tooltip label={t('patients_header_seemore')}>
                    <ActionIcon
                      color={'blue'}
                      variant={'subtle'}
                      onClick={() =>
                        openDrawer({ size: 'md', content: <PatientPrescriptionsDrawer groupList={groupList} /> })
                      }
                    >
                      <BsEye />
                    </ActionIcon>
                  </Tooltip>
                )}
              </Group>
            )}
          </Flex>
        ))}
    </>
  );
};
